//@flow

import { addCodebook } from "./actions.js";
import { addSchema } from "../schema/actions.js";
import * as api from "../api";
import store from "../../../store";

export const download = async function(codebookName: string) {
  const path = `codebook/${codebookName}`;
  let jsonResponse = await api.get(path);

  if ("schema" in jsonResponse) {
    store.dispatch(addSchema(jsonResponse, path));
  }

  if ("list" in jsonResponse) {
    store.dispatch(addCodebook(jsonResponse.name, jsonResponse.list));
    return jsonResponse.list;
  }
  return null;
};

export const downloadURL = async function(url: string) {
  let jsonResponse = await api.get(url);
  if (jsonResponse && "schema" in jsonResponse) {
    store.dispatch(addSchema(jsonResponse, url));
  }

  if (jsonResponse && "list" in jsonResponse) {
    store.dispatch(addCodebook(jsonResponse.name, jsonResponse.list));
    return jsonResponse.list;
  }
  return null;
};
